export const UPDATE_SEARCHTDATA = "UPDATE_SEARCHTDATA";
